import { createSelector } from '@ngrx/store';
import { State } from '../../reducers';
import * as fromEventParams from './event-params.reducer';


export const eventParams = (state: State) => state.eventParams;

export const selectEventFields = createSelector(eventParams, (state: fromEventParams.State) => state.eventParams);
export const selectEventParams = createSelector(eventParams, (state: fromEventParams.State) => state.eventParams);
